module.exports = __webpack_public_path__ + "img/qr1.01ef319.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tpl/qr1.png
// module id = V0Rc
// module chunks = 57